import axios from "axios";
import { get_api_path } from "services/api";

export async function appversion() {
  const url = get_api_path("misc/appversion");
  const response = await axios.get(url);
  const { app_version_name: name, app_version_code: code, app_version_link: link } = response.data.result;
  return { name, code, link };
};